import {combineReducers} from "redux";

import user from "./reducers/user";
import center from "./reducers/center";
import role from "./reducers/role";
import notification from "./reducers/notification";

export const rootReducer = combineReducers({
  user,
  center,
  role,
  notification
});
